import React, { FC } from 'react';
import ChessBoard from './ChessBoard';
import { GameCanvasProps } from '../../components/GameView';

/**
 * Chess game canvas: deserializes the env clone (FEN) and renders the board.
 */
const ChessGameCanvas: FC<GameCanvasProps> = ({ env, active, onSubmit, myPlayer, game }) => {
  const { clone, players } = env;

  return (
    <>
      {clone && (
        <ChessBoard
          active={active}
          onSubmit={onSubmit}
          clone={clone}
          myPlayer={myPlayer}
          players={players}
          gameEnded={game?.status === 'ENDED'}
        />
      )}
    </>
  );
};

export default ChessGameCanvas;
